export default "__VITE_ASSET__BcXv5aTi__"